<div class="flex h-screen bg-gray-100">
  <!-- Sidebar -->
  <aside
    class="relative z-0 flex flex-col bg-white shadow-lg transition-[width] duration-300 ease-in-out bg-cover bg-center bg-[url('assets/images/menu-bg.webp')]"
    [ngClass]="{'w-50': sidebarOpenState || hoverExpanded, 'w-9': !(sidebarOpenState || hoverExpanded), 'absolute h-full z-10': hoverExpanded}"
    (mouseenter)="onSidebarMouseEnter()" (mouseleave)="onSidebarMouseLeave()">
    <div class="absolute inset-0 bg-black/30 -z-10"></div>

    <!-- Logo -->
    <div class="flex items-center h-16 bg-transparent text-white px-0">
      <span class="w-9 flex justify-center shrink-0">
        <img src="/assets/images/FaviconMatwins.png" alt="Matwins Icon" class="w-6 h-6 object-contain shrink-0">
      </span>
      <span
        class="text-2xl font-light bg-transparent uppercase mt-[-15px] inline-block whitespace-nowrap overflow-hidden transition-[max-width,opacity,transform] duration-300 ease-in-out"
        [ngClass]="sidebarOpen ? 'ml-1 max-w-[14rem] opacity-100 translate-x-0' : 'ml-0 max-w-0 opacity-0 -translate-x-2'">{{
      'app.name' | translate }}</span>
      <span class="flex-1"></span>
      @if (sidebarOpen) {
        <label class="relative inline-flex items-center cursor-pointer ml-2 -mt-2">
          <input type="checkbox" [checked]="sidebarOpen" (change)="toggleSidebar()" class="sr-only peer">
          <div
            class="w-4 h-2 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[1px] after:left-[1px] after:bg-white after:border-gray-800 after:border after:rounded-full after:h-1.5 after:w-1.5 after:transition-all peer-checked:bg-orange-600">
          </div>
        </label>
      }
    </div>

    <!-- Navigation -->
    <nav class="relative flex-1 py-4 space-y-2">
      @for (item of menuItems; track item.label) {
        <a [routerLink]="item.route" routerLinkActive="bg-white/30 rounded-none border-0 border-r-[5px] border-r-red-500"
          class="relative z-0 flex items-center py-2 text-xs text-white hover:bg-white/20 hover:rounded-none transition">
          <span class="w-9 flex justify-center shrink-0">
            <i class="{{ item.icon }} w-4 text-center shrink-0"></i>
          </span>
          <span
            class="leading-none inline-block whitespace-nowrap overflow-hidden transition-[max-width,opacity,transform,margin] duration-300 ease-in-out"
            [ngClass]="sidebarOpen ? 'ml-3 max-w-[12rem] opacity-100 translate-x-0' : 'ml-0 max-w-0 opacity-0 -translate-x-2'">{{
          item.label | translate }}</span>
        </a>

      }

    </nav>
  </aside>

  <!-- Main content -->
  <div class="flex-1 flex flex-col overflow-hidden bg-gray-50">
    <!-- Header -->
    <header class="flex justify-between items-center px-6 py-2">
      <!-- Effacement de tous les filtres de la vue d'ensemble -->
      @if (filterStateService.hasActiveFilters) {
      <button type="button"
              data-testid="clear-filters"
              (click)="clearFeatureFilters()"
              class="-ml-4 flex items-center gap-2 px-3 py-1.5 rounded-full border border-blue-400 bg-blue-50 text-blue-800 text-sm font-medium shadow-md hover:bg-blue-100 hover:shadow-lg transition-all">
        <i class="fa-solid fa-circle-xmark"></i>
        {{ 'clear-filters' | translate }}
      </button>
      }

      <!-- Titre principal -->
      <div class="flex-1 text-center">
        <h4 class="inline text-xl font-semibold text-gray-800 mr-2">{{ 'app.title' | translate }}</h4>
        <span class="inline">-</span>
        <p class="inline text-sm text-gray-600 ml-2">{{ 'app.description' | translate }}</p>
      </div>

      <!-- Bloc Language + Login complètement à droite -->
      <div class="flex items-center space-x-4 ml-auto">
        <!-- Language dropdown -->
        <div class="relative flex justify-end mr-[10px]" (clickOutside)="closeLangMenu()">
          <button (click)="toggleLangMenu()" data-testid="layout-lang-selector" class="px-2 py-1 bg-transparent text-xs text-gray-700 flex items-center">
            <i class="fa-solid fa-language mr-1"></i>
            <i class="fas fa-globe mr-2"></i>
            <i class="fas fa-chevron-down ml-1"></i>
          </button>

          @if (langMenuOpen) {
            <div class="absolute top-full right-0 mt-2 w-48 bg-white border rounded-lg shadow-lg z-50">
              <!-- Boucle sur les langues disponibles -->
              @for (lang of languages; track lang.key) {
                <button (click)="changeLanguage(lang.key)" [attr.data-testid]="'layout-lang-option-' + lang.key"
                  [class.bg-blue-50]="currentLanguage === lang.key"
                  class="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 flex items-center">
                  <!-- Utilisation du logoPath si disponible, sinon emoji de fallback -->
                  @if (lang.logoPath) {
                    <img [src]="lang.logoPath" [alt]="lang.name" class="w-4 h-4 mr-2 object-contain">
                  } @else {
                    <span class="mr-2">{{ getFlagEmoji(lang.key) }}</span>
                  }
                  {{ lang.name }} ({{ lang.key }})
                </button>
              }
            </div>
          }
        </div>

        <!-- Fullscreen button -->
        <button (click)="toggleFullscreen()" class="px-2 py-1 bg-transparent text-xs text-gray-700 flex items-center">
          <i class="fa-solid" [ngClass]="isFullscreen ? 'fa-compress' : 'fa-expand'"></i>
        </button>

        <!-- Test Hub : DEBUG uniquement -->
        @if (isDebug) {
          <button type="button" (click)="testHubOpen.set(true)" data-testid="layout-test-hub" title="Test Hub (DEBUG)"
            class="px-2 py-1 bg-transparent text-xs text-orange-600 flex items-center">
            <i class="fas fa-flask"></i>
          </button>
        }

        <!-- Login button -->
        <div class="relative inline-block text-left" (clickOutside)="closeUserMenu()">
          <div class="flex">
            <button type="button" (click)="toggleUserMenu()" data-testid="layout-user-menu" (mouseenter)="showTooltip()" (mouseleave)="hideTooltip()"
              class="inline-flex items-center px-2 py-1 bg-transparent text-white text-xs font-medium relative">
              <i class="fas fa-user text-gray-700"></i>
            </button>
            @if (showUserTooltip) {
              <div
                class="absolute z-20 top-full mt-2 right-0 w-max p-2 bg-white border border-gray-200 rounded-md shadow-lg shadow-gray-400/50 text-sm text-gray-700">
                {{ 'messages.welcome' | translate:{username: authentificationService.userName} }}
              </div>
            }
          </div>
          <!-- Menu déroulant -->
          @if (userMenuOpen) {
            <div
              class="absolute right-0 mt-2 w-56 top-full bg-white border border-gray-200 rounded-md shadow-lg z-10">
              <ul class="py-1 text-sm text-gray-700">
                <li>
                  <button data-testid="layout-logout" class="w-full text-left px-4 py-2 hover:bg-gray-100" (click)="authentificationService.logout()">
                    Log out
                  </button>
                </li>
              </ul>
            </div>
          }
        </div>


      </div>

    </header>

    <!-- Router outlet -->
    <main class="flex-1 overflow-y-auto bg-gray-50 p-0 px-6 min-w-[320px]">
      <router-outlet></router-outlet>
    </main>
  </div>

  <!-- Test Hub (DEBUG uniquement) : modale, l'ecran sous-jacent n'est pas demonte -->
  @if (isDebug) {
    <!-- @defer ne fait que declencher le chargement : le @if interne gere l'affichage. -->
    @defer (when testHubOpen()) {
      @if (testHubOpen()) {
        <div class="fixed inset-0 z-[9998] flex items-center justify-center bg-black/40" data-testid="test-hub-modal"
          (click)="testHubOpen.set(false)">
          <div class="bg-white rounded-xl shadow-2xl overflow-auto max-h-[85vh] w-[80%]" (click)="$event.stopPropagation()">
            <app-test-hub (close)="testHubOpen.set(false)"></app-test-hub>
          </div>
        </div>
      }
    }
  }

  <!-- Loader full-screen moderne -->
  @if (loaderService.loading$ | async) {
    <div
      class="fixed inset-0 bg-gray-900/50 backdrop-blur-sm flex items-center justify-center z-[9999] animate-fadeIn">
      <div class="bg-white rounded-2xl p-8 shadow-2xl flex flex-col items-center space-y-4 animate-slideIn">
        <!-- Spinner animé -->
        <div class="relative">
          <div class="w-16 h-16 border-4 border-gray-200 rounded-full animate-spin border-t-blue-500"></div>
          <div class="absolute inset-0 w-16 h-16 border-4 border-transparent rounded-full animate-ping border-t-blue-300"></div>
        </div>
        <!-- Texte de chargement -->
        <p class="text-gray-700 font-medium text-lg">{{ 'app.loading' | translate }}</p>
        <div class="w-32 h-1 bg-gray-200 rounded-full overflow-hidden">
          <div class="h-full bg-gradient-to-r from-blue-500 to-purple-500 rounded-full animate-pulse"></div>
        </div>
      </div>
    </div>
  }
</div>